import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full darken-on-hover" }
const _hoisted_2 = { class: "w-full relative" }
const _hoisted_3 = {
  key: 1,
  class: "absolute top-0 w-full h-44 z-10"
}
const _hoisted_4 = {
  key: 0,
  class: "absolute flex w-full"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined opacity-100 text-gray-50 text-5xl" }, " cloud_download ", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-base text-muted" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2 text-xs md:text-sm text-muted"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined inline-icon mr-1" }, "info", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined inline-icon mr-1" }, "info", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-xl material-icons-outlined" }, "cloud_upload", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinearProgress = _resolveComponent("LinearProgress")!
  const _component_AnimatedIcon = _resolveComponent("AnimatedIcon")!
  const _component_VueUploadComponent = _resolveComponent("VueUploadComponent")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.uploading)
        ? (_openBlock(), _createBlock(_component_LinearProgress, {
            key: 0,
            progress: _ctx.uploadProgress,
            class: "rounded-t absolute top-0 z-10"
          }, null, 8, ["progress"]))
        : _createCommentVNode("", true),
      (_ctx.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_VueUploadComponent, {
        class: "w-full",
        onInputFilter: _ctx.inputFilter,
        onInputFile: _ctx.inputFile,
        ref: "upload",
        drop: true,
        modelValue: _ctx.files,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.files) = $event)),
        "custom-action": _ctx.emitUpload,
        "input-id": _ctx.elementId
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([[!_ctx.small ? 'h-44' : 'h-20'], "relative flex border-2 border-gray-200 border-dashed rounded cursor-pointer w-full bg-light"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{ invisible: _ctx.files.length > 0 }, "p-4 mx-auto my-auto"])
            }, [
              _createElementVNode("p", {
                class: _normalizeClass(["opacity-30 material-icons-outlined", [!_ctx.small ? 'text-5xl' : 'text-3xl -mt-1.5']])
              }, _toDisplayString(_ctx.disabled ? "file_download_off" : "cloud_upload"), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["opacity-60", [!_ctx.small ? '' : '-mt-2 text-sm']])
              }, _toDisplayString(_ctx.disabled ? _ctx.$t("misc.file_upload_no_files") : _ctx.$t("misc.file_upload")), 3)
            ], 2),
            (_ctx.files.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "relative flex flex-col items-center mx-auto space-x-2 align-middle z-20 w-max p-8 pt-0",
                      key: 'file-' + index + '-' + file.id
                    }, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        class: _normalizeClass([[_ctx.small ? 'py-4' : 'py-16'], "absolute z-50 top-0 hover:bg-opacity-40 transition-all duration-75 hover:opacity-100 hover:bg-gray-500 opacity-0 w-full"])
                      }, _hoisted_6, 2),
                      (false && file.success)
                        ? (_openBlock(), _createBlock(_component_AnimatedIcon, {
                            key: 0,
                            class: "absolute top-0 right-0 mt-2 mr-3"
                          }))
                        : _createCommentVNode("", true),
                      (file.thumb)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: _normalizeClass(["", [_ctx.small ? 'w-10 h-10 mt-2' : 'w-28 h-28 mt-7']]),
                            src: file.thumb
                          }, null, 10, _hoisted_7))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: _normalizeClass(["material-icons-outlined text-gray-400", [_ctx.small ? 'text-3xl mt-2.5' : 'text-5xl mt-12']])
                          }, " insert_drive_file ", 2)),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(file.name), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["onInputFilter", "onInputFile", "modelValue", "custom-action", "input-id"])
    ]),
    (!_ctx.showUpload && _ctx.showMaxSize && !_ctx.fileTooBig)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("misc.max_upload_size_is")) + " " + _toDisplayString(_ctx.humanReadableMaxUploadSize), 1)
        ]))
      : (_ctx.fileTooBig)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: _normalizeClass(["mt-2 text-xs md:text-sm text-muted text-danger-dark", { shake: _ctx.fileTooBigTextShake }]),
            onAnimationend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fileTooBigTextShake = false))
          }, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("misc.file_too_big")) + ".", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("misc.max_upload_size_is")) + " " + _toDisplayString(_ctx.humanReadableMaxUploadSize), 1)
          ], 34))
        : _createCommentVNode("", true),
    (!_ctx.disabled && _ctx.showUpload)
      ? (_openBlock(), _createBlock(_component_Btn, {
          key: 2,
          class: "mt-4",
          loading: _ctx.$refs.upload?.active,
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$refs.upload.active = true), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("misc.upload")), 1)
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true)
  ]))
}